import React from "react";
import { Provider } from "react-redux";
import store from "./Redux/store";
import MainRouter from "./Routes/MainRouter";
import Cart from "./Parts/Cart/Cart";
import Header from "./Parts/Header/Header";
import Menu from "./Parts/Header/Menu/Menu";
import LoadingContainer from "./Parts/LoadingContainer/LoadingContainer";
import PageContent from "./PageContent";
import MobileSearch from "./Parts/Header/Search/MobileSearch";
import Footer from "./Parts/Footer/Footer";
import { initPixels } from "./Pixel";

function MainContainer() {
    initPixels();

    return <Provider store={store}>
        <LoadingContainer>
            <Header />
            <Cart />
            <Menu />
            <MobileSearch />

            <PageContent>
                <MainRouter />
            </PageContent>

            <Footer />
        </LoadingContainer>
    </Provider>
}

export default MainContainer;